import { create } from 'zustand';
import { ApiUtils, FileApi, RequestStrategyEnum } from '@shared/api';
import { FileUtils } from '@shared';

interface IDownloadApplicationFileStore {
  loading: boolean;
  error: string | null;
  downloadApplicationFiles: (request: { fileId: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadApplicationFileStore = create<IDownloadApplicationFileStore>((set) => ({
  loading: false,
  error: null,

  downloadApplicationFiles: ApiUtils.wrapperApi(async (request: { fileId: string; filename: string }, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.downloadApplicationFile(request.fileId, signal);
      FileUtils.downloadFile(result.data, request.filename);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
